import React from 'react';

const SupportText = () => {
  return (
    <div className="mt-4">
      <p>
        By continuing you agree to the{' '}
        <a href="/terms" target="_blank" rel="nofollow">
          Terms of Use
        </a>{' '}
        &{' '}
        <a href="/terms" target="_blank" rel="nofollow">
          Privacy Policy
        </a>
      </p>
    </div>
  );
};

export default SupportText;
